import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import iconCheckmarkStyle from './iconCheckmark.scss';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconCheckmark = (props: IconProps) => (
  <svg
    className={cn(iconCheckmarkStyle.base, iconStyles(props))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 13"
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.8"
      d="M2 6.479L5.348 11 12 2"
    />
  </svg>
);
